/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_3_AnswerInputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_7_questions_3_answer = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_3_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, provided you define which file is authoritative and test the exchange format. For example, keep a dependency-heavy source workbook in Excel and use a separate GridCraft copy for exploration. Make the relationship clear so edits in a downloaded copy are not silently lost when someone returns to the original.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_7_questions_3_answer = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_3_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以，但应明确哪个文件是权威来源，并验证交换格式。例如，保留 Excel 中依赖复杂的源文件，同时用 GridCraft 的独立副本做探索。必须明确两者关系，以免返回原件时忽略下载副本中的修改。`)
};

/**
* | output |
* | --- |
* | "Yes, provided you define which file is authoritative and test the exchange format. For example, keep a dependency-heavy source workbook in Excel and use a se..." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_3_AnswerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_7_questions_3_answer = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_3_AnswerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_3_AnswerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_7_questions_3_answer(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_7_questions_3_answer(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_7_questions_3_answer as "gc.search_guides.gridcraft_vs_excel.sections.7.questions.3.answer" }